import React, { useState, useEffect,useRef  } from "react";
import {
  Button, Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalFooter, Row, ModalHeader,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { useNavigate } from "react-router-dom";
import classnames from "classnames";
import { useMachine } from "../../context/MachineContext";
const Reports = () => {
  const itemsPerPage = 5;
  
  const [activeTab, setActiveTab] = useState("1");
  const navigate = useNavigate();
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
    const selectedMachineId = localStorage.getItem('selectedMachineId');

   //const { selectedMachineId } = useMachine();
  const [machines, setMachines] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
 const [selectedMachine, setSelectedMachine] = useState(selectedMachineId);
   const [date, setDate] = useState("");
 const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedChildPart, setSelectedChildPart] = useState("all");
  //********************************tab2 */
const [ mouldingData, setMouldingData]=useState([]);
  const [reportData, setReportData] = useState({ dates: [], rows: [] });
  const [changeOverConsoData, setChangeOverConsoData] = useState([]);
  const [productionData, setProductionData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [ppmData, setPpmData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [scrapData, setScrapData] = useState([]);
  const [days, setDays] = useState([]);

const getDaysInMonth = (month) => {
  const [year, monthStr] = month.split("-");
  const lastDay = new Date(year, monthStr, 0).getDate();
  return Array.from({ length: lastDay }, (_, i) => i + 1);
};

const processScrapShiftData = (rawData, selectedMonth) => {
  const days = getDaysInMonth(selectedMonth);

  const processed = Object.entries(rawData).map(([partNo, dates]) => {
    const dayWiseShifts = {};
    days.forEach(day => {
      dayWiseShifts[day] = { shift_1: "", shift_2: "", shift_3: "" };
    });

    Object.entries(dates).forEach(([fullDate, shifts]) => {
      const day = new Date(fullDate).getDate();
      dayWiseShifts[day] = {
        shift_1: shifts.shift_1 ?? "",
        shift_2: shifts.shift_2 ?? "",
        shift_3: shifts.shift_3 ?? "",
      };
    });

    return { partNo, shifts: dayWiseShifts };
  });

  return { days, processed };
};


   useEffect(() => {
    if (selectedChildPart && selectedMonth) {
    fetchScrapReport();
    }
  }, [selectedChildPart,selectedMonth]);

    const fetchScrapReport = async () => {
    try {
  setIsLoading(true);
    
      const response = await fetch(`https://api.hanoch.in/reports/scrap_report/?part_id=${selectedChildPart}&month=${selectedMonth}`, {
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, 
        // },
      });
      if (response.ok) {
        const data = await response.json();
        const {days,processed} = processScrapShiftData(data,selectedMonth);
        setDays(days);
        setScrapData(processed);
       
      } else if (response.status === 401) {
        localStorage.removeItem("access");
        localStorage.removeItem("role");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMachines();
    fetchParts();
    
  }, []);
    const fetchMachines = async () => {
    try {
      const response = await fetch("https://api.hanoch.in/api/machines",
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: `Bearer ${authToken}`,
        //   },
        // }
      );

      if (response.ok) {
        const data = await response.json();

        setMachines(data?.data);
        // setSelectedMachine(machines[0].id)

      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("access");
        // localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleMachineChange = async (event) => {
    const selectedId = event.target.value;
    setSelectedMachine(event.target.value);
  };
  useEffect(() => {
    if (selectedMachine && toDate && fromDate) {
      fetchProductionSetup();
      fetchChangeOverConsoSetup();
      fetchPpm();
    }
  }, [selectedMachine, toDate, fromDate]);
  useEffect(() => {
    if (selectedMonth && selectedChildPart) {
      fetchPpm();
      //fetchScrapReport();
    }
  }, [selectedMonth, selectedChildPart]);

 
  const fetchProductionSetup = async () => {
    if (!selectedMachine || !toDate || !fromDate) {
      toast.error("Please select date, from date and to date.");
      return;
    }
    try {
      setIsLoading(true);
      //setFromDate(newDate);
      const response = await fetch(`https://api.hanoch.in/reports/changeover/?machine=${selectedMachine}&start_date=${fromDate}&end_date=${toDate}`, {
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, 
        // },
      });
      if (response.ok) {
        const data = await response.json();
        setProductionData(data);
        console.log("dsda", data)
      } else if (response.status === 401) {
        localStorage.removeItem("access");
        localStorage.removeItem("role");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };
 
  const fetchChangeOverConsoSetup = async () => {
    if (!selectedMachine || !toDate || !fromDate) {
      toast.error("Please select date, from date and to date.");
      return;
    }
    try {
      setIsLoading(true);
      //setFromDate(newDate);
      const response = await fetch(`https://api.hanoch.in/reports/changeover_consolidated/?machine=${selectedMachine}&start_date=${fromDate}&end_date=${toDate}`, {
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, 
        // },
      });
      if (response.ok) {
        const data = await response.json();
        setChangeOverConsoData(data);
        console.log("conso", data)
      } else if (response.status === 401) {
        localStorage.removeItem("access");
        localStorage.removeItem("role");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchPpm = async () => {

    try {
       setIsLoading(true);
      //setFromDate(newDate);
      const response = await fetch(`https://api.hanoch.in/reports/ppm_report/?month=${selectedMonth}&part_no=${selectedChildPart}`, {
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, 
        // },
      });
      if (response.ok) {
        const data = await response.json();
        setPpmData(data);
        console.log("ppm", data)
      } else if (response.status === 401) {
        localStorage.removeItem("access");
        localStorage.removeItem("role");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
       setIsLoading(false);
    }
  };
const [rows,setRows] = useState([]);
const [mouldingdates,setMouldingDates]=useState([]);
const processMouldingData = (data) => {
  const descriptions = [
    "Production",
    "Changeover",
    "Mould Breakdown",
    "Material Unavailable",
    "People Unavailable",
    "Non Declared Hours",
    "Total Hrs Per Day",
  ];

  const mouldingdates = data.map((d) => d.date);

  const rows = descriptions.map((desc) => {
    const daily = data.map((d) => d[desc] || 0);
    const total = daily.reduce((a, b) => a + b, 0);
    const grandTotal = descriptions[0] === desc ? total : null;

    return {
      description: desc,
      daily,
      total: total.toFixed(2),
      percent: descriptions[0] === desc ? "100%" : `${((total / grandTotal) * 100).toFixed(1)}%`,
    };
  });

  return { mouldingdates, rows };
};



  const fetchMoulding = async () => {

    try {
       setIsLoading(true);
      //setFromDate(newDate);
      const response = await fetch (`https://api.hanoch.in/reports/moulding_downtime_report/?machine_id=${selectedMachine}&month=${selectedMonth}`, {
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, 
        // },
      });
      if (response.ok) {
        const data = await response.json();
        const {mouldingdates,rows} = processMouldingData(data);
        setMouldingDates(mouldingdates); 
        setRows(rows);
      } else if (response.status === 401) {
        localStorage.removeItem("access");
        localStorage.removeItem("role");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
       setIsLoading(false);
    }
  };
  useEffect(() => {
  if(selectedMachine && selectedMonth){
    fetchMoulding();
  }
  }, [selectedMachine,selectedMonth]);


  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };


  //******************************tab 5

  const [childParts, setChildParts] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const handlePartChange = (event) => {
    const selectedId = event.target.value;
    setSelectedChildPart(event.target.value);
  };
  const handleShiftChange = (event) => {
    const newShift = event.target.value;
    setSelectedShift(newShift);
    // setFormData((prev) => ({ ...prev, shift: newShift }));
  };
  const isShiftDisabled = (shift) => {
    const now = new Date();
    const currentHour = now.getHours();

    if (shift === "1") {
      return currentHour < 6; // After 2 PM, Shift 1 is over
    } else if (shift === "2") {
      return currentHour < 14; // After 10 PM, Shift 2 is over
    } else if (shift === "3") {
      return currentHour < 22 && currentHour >= 6;
      // Shift 3 (10PM-6AM) is *upcoming* if it's between 6 AM to 10 PM
    }
    return false;
  };
  const getCurrentShift = () => {
    const now = new Date();
    const hours = now.getHours();

    if (hours >= 6 && hours < 14) {
      return 1; // Shift 1: 6am to 2pm
    } else if (hours >= 14 && hours < 22) {
      return 2; // Shift 2: 2pm to 10pm
    } else {
      return 3; // Shift 3: 10pm to 6am
    }
  };
  const [selectedShift, setSelectedShift] = useState(getCurrentShift());

  const fetchParts = async () => {
    try {
      const response = await fetch(
        "https://api.hanoch.in/api/parts",
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: `Bearer ${authToken}`, // Replace with your actual token
        //   },
        // }
      );
      if (response.ok) {
        const childParts = await response.json();

        setChildParts(childParts);

        //selectedChildPart(data[0].number)

      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleFromDateChange = (event) => {
    const newDate = event.target.value;
    setFromDate(newDate);

  };
  const handleToDateChange = (event) => {
    const newDate = event.target.value;
    setToDate(newDate);

  };
  const handleDateChange = (event) => {
    const newDate = event.target.value;
    setDate(newDate);
  };


  //******************************tab 6

const [oeeData, setoeeData] = useState([]);
  const [oeeDates, setOeeDates] = useState([]);
const [machineList,setMachineList]=useState([]);
 useEffect(() => {
  if(selectedMachine&& selectedMonth){
    fetchOeeTeep();
  }
  }, [selectedMachine,selectedMonth]);
 const fetchOeeTeep = async () => {
    try {
         setIsLoading(true);
      const response = await fetch(`https://api.hanoch.in/reports/oee_teep_report/?machine_id=${selectedMachine}&month=${selectedMonth}`)
      if (response.ok) {
        const raw = await response.json();

        // Extract unique dates
        const uniqueDates = [
          ...new Set(raw.map((entry) => entry["Date"])),
        ].sort();

        // Group data by machine
        const grouped = {};
        raw.forEach((item) => {
          const machineList = item["Machine"];
          if (!grouped[machineList]) {
            grouped[machineList] = {};
          }
          grouped[machineList][item["Date"]] = {
            oee: item["OEE (%)"],
            teep: item["TEEP (%)"],
          };
        });

        setOeeDates(uniqueDates);
        setMachineList(Object.entries(grouped)); // [ [machineName, {dateObj}], ... ]
      }
    }
    catch (error) {
      console.error("Error fetching data:", error);
    } finally {
       setIsLoading(false);
    }
  };

  //*************************tab 7 */
  const [oeeTeepTrackingData,setOeeTeepTrackingData]=useState([]);
useEffect(() => {
  if(selectedMachine&& toDate&&fromDate){
    fetchOeeTeepTracking();
  }
  }, [selectedMachine,toDate,fromDate]);

  const fetchOeeTeepTracking = async () => {
    if (!selectedMachine || !toDate || !fromDate) {
      toast.error("Please select date, from date and to date.");
      return;
    }
    try {
      setIsLoading(true);
      //setFromDate(newDate);
      const response = await fetch(`https://api.hanoch.in/reports/oee_teep_tracking/?machine=${selectedMachine}&start_date=${fromDate}&end_date=${toDate}`, {
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, 
        // },
      });
      if (response.ok) {
        const data = await response.json();
        setOeeTeepTrackingData(data);
        console.log("tracking", data)
      } else if (response.status === 401) {
        localStorage.removeItem("access");
        localStorage.removeItem("role");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredPart = productionData.filter((part) =>
    (part.name || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredPart.length / itemsPerPage);

  // Calculate the index of the first and last item of the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get the items for the current page
  const currentItems = filteredPart.slice(indexOfFirstItem, indexOfLastItem);

  // Handle Previous button click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const filteredConsoPart = changeOverConsoData.filter((part) =>
    (part.name || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Calculate the total number of pages
  const totalConsoPages = Math.ceil(filteredConsoPart.length / itemsPerPage);



  // Get the items for the current page
  const currentconsoItems = filteredConsoPart.slice(indexOfFirstItem, indexOfLastItem);
  const handleConsoNext = () => {
    if (currentPage < totalConsoPages) {
      setCurrentPage(currentPage + 1);
    }
  };
 const printRef = useRef();

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload(); // Optional: reload to restore JS behavior
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Report" />

          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => toggle("1")}
                >
                  Scrap Report
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => toggle("2")}
                >
                  Changeover Log Sheet
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "3" })}
                  onClick={() => toggle("3")}
                >
                  Changeover Consolidated
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "4" })}
                  onClick={() => toggle("4")}
                >
                  PPM Report
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "5" })}
                  onClick={() => toggle("5")}
                >
                  Molding DownTime
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "6" })}
                  onClick={() => toggle("6")}
                >
                  OEE & TEEP
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "7" })}
                  onClick={() => toggle("7")}
                >
                  OEE & TEEP Tracking
                </NavLink>
              </NavItem>

              {/* Add more tabs here */}
            </Nav>

            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                {/* <h5>Scrap Report Content</h5> */}
                 <div    className="d-flex flex-wrap align-items-center mb-3 mt-3"
                  style={{
                    gap: "12px",
                    padding: "12px 16px",
                    backgroundColor: "#252b3b",
                    color: "#c9d1d9",
                    borderRadius: "6px",
                    width: "100%"
                  }}>
                
                  <div className="d-flex align-items-center">

                    <label htmlFor="part-description" className="form-label">part </label>
                    <select
                      className="form-control"
                      id="machine"
                      name="selectedPart"
                      value={selectedChildPart}
                      onChange={handlePartChange}
                    >
                      <option key="default" value="all">All</option>
                      {childParts?.map((part, index) => (
                        <option key={index} value={part.id}>
                          {part.name}
                        </option>
                      ))}
                    </select>
                  </div>

               <div className=" d-flex align-items-center">
                    <label htmlFor="part-description" className="form-label">
                      Month
                    </label>
                    <div className="col-md-10">

                      <input
                        type="month"
                        value={selectedMonth}
                        onChange={handleMonthChange}
                        max={new Date().toISOString().split('T')[0].slice(0, 7)}

                      />  </div>
                  </div>
                 
                 
                </div>

                <div className="hstack gap-2 justify-content-between">
                  <button
                    type="button"
                    className="btn btn-secondary"
                  // onClick={() => setModalVisible(false)}
                  >
                    Refresh
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary"
                 onClick={handlePrint}
                  >
                    Print
                  </button>

                </div>
                 {isLoading ? (
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
<div ref={printRef} className="table-responsive table-card mt-3 mb-1">
  <table className="table table-bordered table-striped table-sm text-center align-middle">
    <thead className="table-dark">
        <tr className="table-secondary">
      <th colSpan={2 + days.length * 3} className="text-center fs-5 text-uppercase">
        Scrap Report
      </th>
    </tr>
      <tr>
        <th rowSpan="2">Sl No</th>
        <th rowSpan="2">Part No</th>
        {days.map(day => (
          <th key={day} colSpan="3">{day}</th>
        ))}
      </tr>
      <tr>
        {days.map(day => (
          <>
            <th key={`s1-${day}`}>S1</th>
            <th key={`s2-${day}`}>S2</th>
            <th key={`s3-${day}`}>S3</th>
          </>
        ))}
      </tr>
    </thead>
    <tbody>
      {scrapData.map((row, idx) => (
        <tr key={idx}>
          <td>{idx + 1}</td>
          <td>{row.partNo}</td>
          {days.map(day => (
            <>
              <td key={`d${day}-s1`}>{row.shifts[day].shift_1}</td>
              <td key={`d${day}-s2`}>{row.shifts[day].shift_2}</td>
              <td key={`d${day}-s3`}>{row.shifts[day].shift_3}</td>
            </>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
</div>
                )}

              </TabPane>
              <TabPane tabId="2">
                {/* <h5>Changeover Log Sheet Content</h5> */}

                <div className="d-flex flex-wrap align-items-center mb-3 mt-3"
                  style={{
                    gap: "12px",
                    padding: "12px 16px",
                    backgroundColor: "#252b3b",
                    color: "#c9d1d9",
                    borderRadius: "6px",
                    width: "100%"
                  }}>
                  <div className="d-flex align-items-center">
                    <label htmlFor="id-field" className="form-label">
                      Machine
                    </label>
                    <select
                      className="form-control"
                      id="machine"
                      name="selectedMachine"
                      value={selectedMachine}
                      onChange={handleMachineChange}
                    >
                      <option value="">Select Machine</option>
                      {machines?.map((machine) => (
                        <option key={machine.id} value={machine.id}>
                          {machine.name}
                        </option>
                      ))}

                    </select>
                  </div>
                  <div className="d-flex align-items-center">

                    <label htmlFor="part-description" className="form-label">Part </label>
                    <select
                      className="form-control"
                      id="machine"
                      name="selectedPart"
                      value={selectedChildPart}
                      onChange={handlePartChange}
                    >
                      <option key="default" value="all">All</option>
                      {childParts?.map((part, index) => (
                        <option key={index} value={part.id}>
                          {part.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className=" d-flex align-items-center">
                    <label htmlFor="part-description" className="form-label" style={{

                      marginRight: "6px",
                      marginBottom: 0,

                    }}>
                      From Date
                    </label>
                    <div className="col-md-12">

                      <input
                        type="date"
                        value={fromDate}
                        onChange={handleFromDateChange}
                        max={new Date().toISOString().split('T')[0]}  // restrict future date

                      />  </div>
                  </div>
                  <div className=" d-flex align-items-center">
                    <label htmlFor="part-description" className="form-label" style={{

                      marginRight: "6px",
                      marginBottom: 0,

                    }}>
                      To Date  </label>
                    <div className="col-md-12">

                      <input
                        type="date"
                        value={toDate}
                        onChange={handleToDateChange}
                        max={new Date().toISOString().split('T')[0]}  // restrict future date

                      />  </div>
                  </div>
                </div>

                <div className="hstack gap-2 justify-content-between">
                  <button
                    type="button"
                    className="btn btn-secondary"
                  // onClick={() => setModalVisible(false)}
                  >
                    Refresh
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary"
                  // onClick={() => setModalVisible(false)}
                  >
                    Print
                  </button>

                </div>
                {isLoading ? (
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <div className="table-responsive table-card mt-3 mb-1">
                    <table
                      className="table align-middle table-nowrap"
                      id="customerTable"
                    >
                      <thead className="table-light">
                           <tr className="table-secondary">
        <th colSpan="10" className="text-center fs-5 text-uppercase">
          Changeover Log Sheet
        </th>
      </tr>
                        <tr>
                          <th className="sort" data-sort="customer_name">
                            Date
                          </th>
                          <th className="sort" data-sort="email">
                            Time
                          </th>
                          <th className="sort" data-sort="phone">
                            New Reference
                          </th>

                          <th className="sort" data-sort="action">
                            Duration(min)
                          </th>
                          <th className="sort" data-sort="action">
                            Bad parts
                          </th>
                          <th className="sort" data-sort="action">
                            Previous Batch Quantity
                          </th>
                          <th className="sort" data-sort="action">
                            Comments
                          </th>

                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {currentItems === undefined ? (
                          <tr>
                            <td colSpan="9" className="text-center">
                              Loading...
                            </td>
                          </tr>
                        ) : currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="9" className="text-center">
                              No content found
                            </td>
                          </tr>
                        ) : (
                          currentItems.map((part, index) => (
                            <tr key={index} onClick={() => navigate("/batch-control-page", { state: { part } })}
                              style={{
                                cursor: "pointer"
                              }} >

                              <td className="part_name">
                                {part.date}
                              </td>
                              <td className="part_number">
                                {part.start_time}-{part?.end_time}
                              </td>
                              <td className="email">
                                {part?.new_reference}
                              </td>
                              <td className="email">
                                {part.duration}
                              </td>
                              <td className="email">
                                {part?.bad_parts}
                              </td>
                              <td className="email">
                                {part?.previous_batch_quantity}
                              </td>
                              <td className="email">
                                {part?.comments}
                              </td>

                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                    <div className="noresult" style={{ display: "none" }}>
                      <div className="text-center">
                        <lord-icon
                          src="https://cdn.lordicon.com/msoeawqm.json"
                          trigger="loop"
                          colors="primary:#121331,secondary:#08a88a"
                          style={{ width: "75px", height: "75px" }}
                        ></lord-icon>
                        <h5 className="mt-2">Sorry! No Result Found</h5>
                        <p className="text-muted mb-0">
                          We've searched more than 150+ Orders We did not find
                          any orders for you search.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                <div className="d-flex justify-content-end">
                  <div className="pagination-wrap hstack gap-2">
                    <Link
                      className={`page-item pagination-prev ${currentPage === 1 ? "disabled" : ""
                        }`}
                      to="#"
                      onClick={handlePrevious}
                    >
                      Previous
                    </Link>
                    <ul className="pagination listjs-pagination mb-0">
                      <li>
                        Page {currentPage} of {totalPages}
                      </li>
                    </ul>
                    <Link
                      className={`page-item pagination-next ${currentPage === totalPages ? "disabled" : ""
                        }`}
                      to="#"
                      onClick={handleNext}
                    >
                      Next
                    </Link>
                  </div>
                </div>

              </TabPane>
              <TabPane tabId="3">
                {/* <h5>Changeover Consolidated Content</h5> */}

                <div className="d-flex flex-wrap align-items-center mb-3 mt-3"
                  style={{
                    gap: "12px",
                    padding: "12px 16px",
                    backgroundColor: "#252b3b",
                    color: "#c9d1d9",
                    borderRadius: "6px",
                    width: "100%"
                  }}>
                  <div className="d-flex align-items-center">
                    <label htmlFor="id-field" className="form-label">
                      Select machine
                    </label>
                    <select
                      className="form-control"
                      id="machine"
                      name="selectedMachine"
                      value={selectedMachine}
                      onChange={handleMachineChange}
                    >
                      <option value="">Select Machine</option>
                      {machines?.map((machine) => (
                        <option key={machine.id} value={machine.id}>
                          {machine.name}
                        </option>
                      ))}

                    </select>
                  </div>
                  <div className="d-flex align-items-center">

                    <label htmlFor="part-description" className="form-label">Select part </label>
                    <select
                      className="form-control"
                      id="machine"
                      name="selectedPart"
                      value={selectedChildPart}
                      onChange={handlePartChange}
                    >
                      <option key="default"value="all">All</option>
                      {childParts?.map((part, index) => (
                        <option key={index} value={part.id}>
                          {part.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className=" d-flex align-items-center">
                    <label htmlFor="part-description" className="form-label" style={{

                      marginRight: "6px",
                      marginBottom: 0,

                    }}>
                      From Date
                    </label>
                    <div className="col-md-12">

                      <input
                        type="date"
                        value={fromDate}
                        onChange={handleFromDateChange}
                        max={new Date().toISOString().split('T')[0]}  // restrict future date

                      />  </div>
                  </div>
                  <div className=" d-flex align-items-center">
                    <label htmlFor="part-description" className="form-label" style={{

                      marginRight: "6px",
                      marginBottom: 0,

                    }}>
                      To Date  </label>
                    <div className="col-md-12">

                      <input
                        type="date"
                        value={toDate}
                        onChange={handleToDateChange}
                        max={new Date().toISOString().split('T')[0]}  // restrict future date

                      />  </div>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="topic-field" className="form-label">
                      select shift
                    </label>
                    <select
                      className="form-control"
                      id="shift"
                      name="shift"
                      value={selectedShift}
                      onChange={handleShiftChange}
                    >
                      <option value="" >Select a shift</option>
                      <option value="1" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("1")} >6-2 (Shift 1)</option>
                      <option value="2" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("2")}>2-10 (Shift 2)</option>
                      <option value="3" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("3")}>10-6 (Shift 3)</option>
                    </select>
                  </div>
                </div>

                <div className="hstack gap-2 justify-content-between">
                  <button
                    type="button"
                    className="btn btn-secondary"
                  // onClick={() => setModalVisible(false)}
                  >
                    Refresh
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary"
                  // onClick={() => setModalVisible(false)}
                  >
                    Print
                  </button>

                </div>
                {isLoading ? (
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <div className="table-responsive table-card mt-3 mb-1">
                    <table
                      className="table align-middle table-nowrap"
                      id="customerTable"
                    >
                      <thead className="table-light">
                            <tr className="table-secondary">
        <th colSpan="10" className="text-center fs-5 text-uppercase">
          Changeover Consolidated
        </th>
      </tr>
                        <tr>
                          <th className="sort" data-sort="customer_name">
                            Date
                          </th>
                          <th className="sort" data-sort="email">
                            Shift
                          </th>
                          <th className="sort" data-sort="phone">
                            Changeover End Time
                          </th>

                          <th className="sort" data-sort="action">
                            Machine
                          </th>
                          <th className="sort" data-sort="action">
                            New Part No
                          </th>
                          <th className="sort" data-sort="action">
                            Part Description
                          </th>
                          <th className="sort" data-sort="action">
                            Duration(min)
                          </th>
                          <th className="sort" data-sort="action">
                            Comments
                          </th>

                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {currentconsoItems === undefined ? (
                          <tr>
                            <td colSpan="9" className="text-center">
                              Loading...
                            </td>
                          </tr>
                        ) : currentconsoItems.length === 0 ? (
                          <tr>
                            <td colSpan="9" className="text-center">
                              No content found
                            </td>
                          </tr>
                        ) : (
                          currentconsoItems.map((part, index) => (
                            <tr key={index}
                              style={{
                                cursor: "pointer"
                              }} >

                              <td className="part_name">
                                {part?.date}
                              </td>
                              <td className="part_number">
                                {part.shift}
                              </td>
                              <td className="part_new_ref">
                                {part?.changeover_endtime}
                              </td>
                              <td className="part_shift">
                                {part.machine}
                              </td>
                              <td className="part_bad">
                                {part?.new_part_no}
                              </td>
                              <td className="part_batch_qua">
                                {part?.new_part_description}
                              </td>
                              <td className="part_batch_qua">
                                {part?.duration}
                              </td>
                              <td className="part_comments">
                                {part?.comments}
                              </td>

                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                    <div className="noresult" style={{ display: "none" }}>
                      <div className="text-center">
                        <lord-icon
                          src="https://cdn.lordicon.com/msoeawqm.json"
                          trigger="loop"
                          colors="primary:#121331,secondary:#08a88a"
                          style={{ width: "75px", height: "75px" }}
                        ></lord-icon>
                        <h5 className="mt-2">Sorry! No Result Found</h5>
                        <p className="text-muted mb-0">
                          We've searched more than 150+ Orders We did not find
                          any orders for you search.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                <div className="d-flex justify-content-end">
                  <div className="pagination-wrap hstack gap-2">
                    <Link
                      className={`page-item pagination-prev ${currentPage === 1 ? "disabled" : ""
                        }`}
                      to="#"
                      onClick={handlePrevious}
                    >
                      Previous
                    </Link>
                    <ul className="pagination listjs-pagination mb-0">
                      <li>
                        Page {currentPage} of {totalPages}
                      </li>
                    </ul>
                    <Link
                      className={`page-item pagination-next ${currentPage === totalPages ? "disabled" : ""
                        }`}
                      to="#"
                      onClick={handleConsoNext}
                    >
                      Next
                    </Link>
                  </div>
                </div>

              </TabPane>

              <TabPane tabId="4">
                {/* <h5>PPM REPORT</h5> */}
                <div className="d-flex flex-wrap align-items-center mb-3"
                  style={{
                    gap: "12px",
                    padding: "12px 16px",
                    backgroundColor: "#252b3b",
                    color: "#c9d1d9",
                    borderRadius: "6px",
                    width: "100%"
                  }}>
                  <div className="d-flex align-items-center">
                    <label style={{
                      fontSize: "13px",
                      marginRight: "6px",
                      marginBottom: 0,
                      color: "#8b949e"
                    }}>Select part:</label>
                    <select
                      className="form-control"
                      id="machine"
                      name="selectedMachine"
                      value={selectedChildPart}
                      onChange={handlePartChange}
                    >
                      <option key="default" value="all">All</option>
                      {childParts?.map((part, index) => (
                        <option key={index} value={part.id}>
                          {part.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className=" d-flex align-items-center">
                    <label htmlFor="part-description" className="form-label">
                      select month
                    </label>
                    <div className="col-md-10">

                      <input
                        type="month"
                        value={selectedMonth}
                        onChange={handleMonthChange}
                        max={new Date().toISOString().split('T')[0].slice(0, 7)}

                      />  </div>
                  </div>
                </div>

                <div className="hstack gap-2 justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary"
                  // onClick={() => setModalVisible(false)}
                  >
                    Refresh
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary"
                  // onClick={() => setModalVisible(false)}
                  >
                    Print
                  </button>

                </div>
  {isLoading ? (
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                <div className="table-responsive table-card mt-3 mb-1">
                  <table
                    className="table align-middle table-nowrap"
                    id="customerTable"
                  >
                    <thead className="table-light">
                          <tr className="table-secondary">
        <th colSpan="10" className="text-center fs-5 text-uppercase">
          PPM Report
        </th>
      </tr>
                      <tr>
                        <th className="sort" data-sort="customer_name">
                          SL No
                        </th>
                        <th className="sort" data-sort="email">
                          Part No
                        </th>
                        <th className="sort" data-sort="phone">
                          Part Name
                        </th>

                        <th className="sort" data-sort="action">
                          Production Qty
                        </th>
                        <th className="sort" data-sort="action">
                          Molding Ok Qty
                        </th>
                        <th className="sort" data-sort="action">
                          Total Rej Qty
                        </th>
                        <th className="sort" data-sort="action">
                          Total Rej (in %)
                        </th>
                        <th className="sort" data-sort="action">
                          Total Rej - PPM
                        </th>
                      </tr>
                    </thead>
                    <tbody className="list form-check-all">
                      {ppmData === undefined ? (
                        <tr>
                          <td colSpan="9" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : ppmData.length === 0 ? (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No content found
                          </td>
                        </tr>
                      ) : (
                        ppmData.map((part, index) => (
                          <tr key={index} onClick={() => navigate("/batch-control-page", { state: { part } })}
                            style={{
                              cursor: "pointer"
                            }} >

                            <td className="part_name">
                              {part.sl_no}
                            </td>
                            <td className="part_number">
                              {part.part_no}
                            </td>
                            <td className="part_number">
                              {part.part_name}
                            </td>
                            <td className="email">
                              {part?.production_qty}
                            </td>
                            <td className="email">
                              {part.molding_ok_qty}
                            </td>
                            <td className="email">
                              {part?.total_rej_qty}
                            </td>
                            <td className="email">
                              {part?.total_rej}
                            </td>
                            <td className="email">
                              {part?.total_rej}
                            </td>

                          </tr>
                        ))
                      )}




                    </tbody>
                  </table>
                  <div className="noresult" style={{ display: "none" }}>
                    <div className="text-center">
                      <lord-icon
                        src="https://cdn.lordicon.com/msoeawqm.json"
                        trigger="loop"
                        colors="primary:#121331,secondary:#08a88a"
                        style={{ width: "75px", height: "75px" }}
                      ></lord-icon>
                      <h5 className="mt-2">Sorry! No Result Found</h5>
                      <p className="text-muted mb-0">
                        We've searched more than 150+ Orders We did not find
                        any orders for you search.
                      </p>
                    </div>
                  </div>
                </div>
                )}
              </TabPane>
              <TabPane tabId="5">
                {/* <h5>Molding</h5> */}
 <div className="d-flex flex-wrap align-items-center mb-3"
                  style={{
                    gap: "12px",
                    padding: "12px 16px",
                    backgroundColor: "#252b3b",
                    color: "#c9d1d9",
                    borderRadius: "6px",
                    width: "100%"
                  }}>
                     <div className="d-flex align-items-center">
                    <label htmlFor="id-field" className="form-label">
                      Select machine
                    </label>
                    <select
                      className="form-control"
                      id="machine"
                      name="selectedMachine"
                      value={selectedMachine}
                      onChange={handleMachineChange}
                    >
                      <option value="">Select Machine</option>
                      {machines?.map((machine) => (
                        <option key={machine.id} value={machine.id}>
                          {machine.name}
                        </option>
                      ))}

                    </select>
                  </div>
                  <div className=" d-flex align-items-center">
                    <label htmlFor="part-description" className="form-label">
                      select month
                    </label>
                    <div className="col-md-10">

                      <input
                        type="month"
                        value={selectedMonth}
                        onChange={handleMonthChange}
                        max={new Date().toISOString().split('T')[0].slice(0, 7)}

                      />  </div>
                  </div>
                  </div>
                    <div className="hstack gap-2 justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary"
                  // onClick={() => setModalVisible(false)}
                  >
                    Refresh
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary"
                  // onClick={() => setModalVisible(false)}
                  >
                    Print
                  </button>

                </div>
                  {isLoading ? (
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                 <div className="table-responsive table-card mt-3 mb-1">
                <table className="table table-bordered table-striped table-sm">
                  <thead className="table-dark text-center">
                        <tr className="table-secondary">
        <th colSpan="10" className="text-center fs-5 text-uppercase">
         Molding Down Time Report
        </th>
      </tr>
                    <tr>
                      <th>Sl No</th>
                      <th>Description/Contributors</th>
                      {mouldingdates.map((date, idx) => (
                        <th key={idx}>{date}</th>
                      ))}
                      <th>Total</th>
                      <th>As %</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, rowIdx) => (
                      <tr key={rowIdx}>
                        <td>{rowIdx + 1}</td>
                        <td>{row.description}</td>
                        {row.daily.map((val, valIdx) => (
                          <td key={valIdx} className="text-end">{val.toFixed(2)}</td>
                        ))}
                        <td className="text-end">{row.total}</td>
                        <td className="text-end">{row.percent}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
</div>
                )}
              </TabPane>
              <TabPane tabId="6">
                {/* <h5>OEE&TEEP</h5> */}
                <div className="d-flex flex-wrap align-items-center mb-3 mt-3"
                  style={{
                    gap: "12px",
                    padding: "12px 16px",
                    backgroundColor: "#252b3b",
                    color: "#c9d1d9",
                    borderRadius: "6px",
                    width: "100%"
                  }}>
                  <div className="d-flex align-items-center">
                    <label htmlFor="id-field" className="form-label">
                     Machine
                    </label>
                    <select
                      className="form-control"
                      id="machine"
                      name="selectedMachine"
                      value={selectedMachine}
                      onChange={handleMachineChange}
                    >
                      <option value="">Select Machine</option>
                      {machines?.map((machine) => (
                        <option key={machine.id} value={machine.id}>
                          {machine.name}
                        </option>
                      ))}

                    </select>
                  </div>
                 

                  <div className=" d-flex align-items-center">
                    <label htmlFor="part-description" className="form-label" style={{

                      marginRight: "6px",
                      marginBottom: 0,

                    }}>
                     Month
                    </label>
                    <div className="col-md-12">

                      <input
                        type="month"
                        value={selectedMonth}
                        onChange={handleMonthChange}
                        max={new Date().toISOString().split('T')[0].slice(0, 7)}

                      />  </div>
                  </div>
                
                </div>

                <div className="hstack gap-2 justify-content-between">
                  <button
                    type="button"
                    className="btn btn-secondary"
                  // onClick={() => setModalVisible(false)}
                  >
                    Refresh
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary"
                  // onClick={() => setModalVisible(false)}
                  >
                    Print
                  </button>

                </div>
                  {isLoading ? (
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                <div className="table-responsive mt-2">
                  <table className="table table-bordered text-center table-sm">
                    <thead className="table-dark">
                          <tr className="table-secondary">
        <th colSpan="10" className="text-center fs-5 text-uppercase">
        OEE&TEEP Report
        </th>
      </tr>
                      <tr>
                        <th colSpan={2 + oeeDates.length}>OEE (%)</th>
                      </tr>
                      <tr>
                        <th>Sl No</th>
                        <th>Machine</th>
                        {oeeDates.map((date) => (
                          <th key={date}>{date}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {machineList.map(([machineName, dateMap], idx) => (
                        <tr key={machineName}>
                          <td>{idx + 1}</td>
                          <td>{machineName}</td>
                          {oeeDates.map((date) => (
                            <td key={date}>
                              {dateMap[date]?.oee ? dateMap[date].oee.toFixed(2) : 0}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>

                    <thead className="table-dark">
                      <tr>
                        <th colSpan={2 + oeeDates.length}>TEEP (%)</th>
                      </tr>
                      <tr>
                        <th>Sl No</th>
                        <th>Machine</th>
                        {oeeDates.map((date) => (
                          <th key={date}>{date}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {machineList.map(([machineName, dateMap], idx) => (
                        <tr key={machineName}>
                          <td>{idx + 1}</td>
                          <td>{machineName}</td>
                          {oeeDates.map((date) => (
                            <td key={date}>
                              {dateMap[date]?.teep ? dateMap[date].teep.toFixed(2) : 0}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                )}
              </TabPane>
              <TabPane tabId="7">
                {/* <h5>OEE TEEP .......</h5> */}
   <div className="d-flex flex-wrap align-items-center mb-3 mt-3"
                  style={{
                    gap: "12px",
                    padding: "12px 16px",
                    backgroundColor: "#252b3b",
                    color: "#c9d1d9",
                    borderRadius: "6px",
                    width: "100%"
                  }}>
                  <div className="d-flex align-items-center">
                    <label htmlFor="id-field" className="form-label">
                      Machine
                    </label>
                    <select
                      className="form-control"
                      id="machine"
                      name="selectedMachine"
                      value={selectedMachine}
                      onChange={handleMachineChange}
                    >
                      <option value="">Select Machine</option>
                      {machines?.map((machine) => (
                        <option key={machine.id} value={machine.id}>
                          {machine.name}
                        </option>
                      ))}

                    </select>
                  </div>
                 

                  <div className=" d-flex align-items-center">
                    <label htmlFor="part-description" className="form-label" style={{

                      marginRight: "6px",
                      marginBottom: 0,

                    }}>
                      From Date
                    </label>
                    <div className="col-md-12">

                      <input
                        type="date"
                        value={fromDate}
                        onChange={handleFromDateChange}
                        max={new Date().toISOString().split('T')[0]}  // restrict future date

                      />  </div>
                  </div>
                  <div className=" d-flex align-items-center">
                    <label htmlFor="part-description" className="form-label" style={{

                      marginRight: "6px",
                      marginBottom: 0,

                    }}>
                      To Date  </label>
                    <div className="col-md-12">

                      <input
                        type="date"
                        value={toDate}
                        onChange={handleToDateChange}
                        max={new Date().toISOString().split('T')[0]}  // restrict future date

                      />  </div>
                  </div>
                </div>
                  <div className="hstack gap-2 justify-content-between">
                  <button
                    type="button"
                    className="btn btn-secondary"
                  // onClick={() => setModalVisible(false)}
                  >
                    Refresh
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary"
                  // onClick={() => setModalVisible(false)}
                  >
                    Print
                  </button>

                </div>
                  {isLoading ? (
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                <div className="table-responsive mt-2">
      <table className="table table-bordered table-sm table-striped">
        <thead className="table-dark">
              <tr className="table-secondary">
        <th colSpan="10" className="text-center fs-5 text-uppercase">
         OEE&TEEP Tracking
        </th>
      </tr>
          <tr>
            <th>Sl No</th>
            <th>Machine No</th>
            <th>Description</th>
            <th>Tonnage</th>
            <th>OEE</th>
            <th>TEEP</th>
            <th>Good Part</th>
            <th>Bad Part</th>
            <th>Production Min</th>
            <th>Down Min</th>
            <th>Idle Min</th>
            <th>C/O Min</th>
            <th>Total Min</th>
          </tr>
        </thead>
        <tbody>
          {oeeTeepTrackingData.length > 0 ? oeeTeepTrackingData.map((row, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{row.machine_no}</td>
              <td>{row.machine_description}</td>
              <td>{row.tonnage}</td>
              <td>{row.oee}</td>
              <td>{row.teep}</td>
              <td>{row.good_part}</td>
              <td>{row.bad_part}</td>
              <td>{row.production_min}</td>
              <td>{row.down_min}</td>
              <td>{row.idle_min}</td>
              <td>{row.co_min}</td>
              <td>{row.total_min}</td>
            </tr>
          )) : (
            <tr>
              <td colSpan="13" className="text-center">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
</div>
                )}
              </TabPane>
              {/* More TabPane components for each tab */}
            </TabContent>
          </div>
        </Container>
      </div>

    </React.Fragment>
  );
};

export default Reports;

